// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import Image from "next/image";

import { Box, Grid, Typography } from "@/components/core";
import { CURRENCY_CODE_TO_FLAG_PATH } from "@/utils/constants/common";

export function CurrencyFlag({ currency, width = 40, height = 40 }) {
  const CURRENCY_LABEL = {
    TL: "Türk Lirası",
    USD: "Amerikan Doları",
    EUR: "Euro",
    GBP: "İngiliz Sterlini",
  };

  return (
    <Box sx={{ textAlign: "left" }}>
      <Grid spacing={2} justifyContent="flex-start" alignItems="center">
        <Grid.Item>
          <Image
            width={width}
            height={height}
            src={CURRENCY_CODE_TO_FLAG_PATH[currency]}
            alt="country-flag"
          />
        </Grid.Item>
        <Grid.Item>
          <Typography sx={{ fontSize: `${height / 2}px` }}>{currency}</Typography>
        </Grid.Item>
      </Grid>
      <Typography variant="caption">{CURRENCY_LABEL[currency]}</Typography>
    </Box>
  );
}

CurrencyFlag.propTypes = {
  currency: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
